import { Avatar, Grid, Typography } from "@mui/material";
import { City, Professional, Team } from "@syadem/ariane-js";
import mesVaccinsLogo from "../../../assets/mesvaccinsLogoSquare.jpeg";
import { useI18n } from "../../hooks/useI18n";
import { CitySearchField } from "./CitySearchField";
import { ProfessionalSearchField } from "./ProfessionalSearchField";

export function CityAndProAutocomplete({
  city,
  cityError,
  onCityChange,
  professional,
  professionalError,
  onProfessionalChange,
  onArianeError,
}: {
  city?: City;
  cityError?: boolean;
  onCityChange: (city?: City) => void;
  professional?: Professional | Team;
  professionalError?: boolean;
  onProfessionalChange: (professional?: Professional | Team) => void;
  onArianeError?: (error: unknown) => void;
}) {
  const { t } = useI18n();

  return (
    <>
      <Grid container size={{ xs: 12, md: 6 }}>
        <CitySearchField
          city={city}
          onCityChange={onCityChange}
          splitZipCode
          onProfessionalChange={onProfessionalChange}
          professional={professional}
          cityError={cityError}
          required
          onArianeError={onArianeError}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <ProfessionalSearchField
          city={city}
          professional={professional}
          professionalError={professionalError}
          onProfessionalChange={onProfessionalChange}
          onArianeError={onArianeError}
        />
      </Grid>
      <Grid size={12}>
        <Typography variant="caption" color="info" sx={{ display: "inline-flex" }}>
          <Avatar
            src={mesVaccinsLogo}
            title={t("common.subscribed")}
            sx={{ width: 16, height: 16, mr: 1 }}
            alt="mesvaccins.net logo"
          />
          {t("common.subscribedLogo")}
        </Typography>
      </Grid>
    </>
  );
}
